import { Box, Grid, Typography } from "@mui/material";
import { convertMetersToKilometers, getDirectionFromDeg, getPreciseTimeOnlyString } from "../helpers/weather-helpers";
import { DailyWeather, DailyWeatherUnit, HourlyAirQualityIndex, HourlyWeather, HourlyWeatherUnit, airQualityIndexCodes, uvIndexCodes } from "../types/Weather";

const WeatherCurrentDetailsSection =
  ({ dailyWeather, hourlyWeather, dailyWeatherUnit, hourlyWeatherUnit, currentAirQualityIndex, currentWindSpeed, currentWindDirection, headerText, disablePadding }: {
    dailyWeather: DailyWeather,
    hourlyWeather: HourlyWeather[],
    dailyWeatherUnit: DailyWeatherUnit,
    hourlyWeatherUnit: HourlyWeatherUnit,
    currentWindSpeed?: number,
    currentWindDirection?: number,
    currentAirQualityIndex?: HourlyAirQualityIndex,
    headerText: string,
    disablePadding?: boolean,
  }) => {
    return (
      <>
        <Box sx={{ marginY: disablePadding ? 0 : 4 }}>
          {headerText ? <Typography variant="body1" sx={{ fontWeight: '600', marginBottom: 2 }}>{headerText}</Typography> : <></>}
          <Box sx={{ display: "flex" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1" color="gray">High / Low</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  {dailyWeather.temperature_2m_max.toFixed(0)}{dailyWeatherUnit.temperature_2m_max} /&nbsp;
                  {dailyWeather.temperature_2m_min.toFixed(0)}{dailyWeatherUnit.temperature_2m_min}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1" color="gray">Precipitation</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{dailyWeather.precipitation_probability_mean}{dailyWeatherUnit.precipitation_probability_mean}</Typography>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1" color="gray">Humidity</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{hourlyWeather[0].relativehumidity_2m}{hourlyWeatherUnit.relativehumidity_2m}</Typography>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1" color="gray">Visibility</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{convertMetersToKilometers(hourlyWeather[0].visibility)}km</Typography>
              </Grid>
            </Grid>
          </Box>
          {
            currentWindSpeed && currentWindDirection
              ?
              <Box sx={{ display: "flex" }}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body1" color="gray">Wind</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body1">
                      {currentWindSpeed.toFixed(0)}km/h {getDirectionFromDeg(currentWindDirection)}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              :
              <></>
          }
          <Box sx={{ display: "flex" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1" color="gray">UV Index</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  {dailyWeather.uv_index_max.toFixed(0)}{dailyWeatherUnit?.uv_index_max}, {uvIndexCodes(Math.round(dailyWeather.uv_index_max))}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          {
            currentAirQualityIndex && currentAirQualityIndex.us_aqi
              ?
              <Box sx={{ display: "flex" }}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body1" color="gray">Air Quality</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body1">
                      {airQualityIndexCodes(currentAirQualityIndex.us_aqi)}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              :
              <></>
          }
          <Box sx={{ display: "flex" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1" color="gray">Sunrise</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{getPreciseTimeOnlyString(dailyWeather.sunrise)}</Typography>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1" color="gray">Sunset</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{getPreciseTimeOnlyString(dailyWeather.sunset)}</Typography>
              </Grid>
            </Grid>
          </Box>
        </Box >
      </>
    );
  }

export default WeatherCurrentDetailsSection;